import SparkMD5 from 'spark-md5';
// import {actions as notifActions} from 're-notif';
import _intersection from 'lodash/intersection';
import _isEmpty from 'lodash/isEmpty';
import _concat from 'lodash/concat';
import React from 'react';

const UPLOAD_FILE =
  'pages/eyewear/addoreditframe/components/eyeweareditor/components/fileupload/UPLOAD_FILE';
const UPLOAD_FILE_SUCCESS =
  'pages/eyewear/addoreditframe/components/eyeweareditor/components/fileupload/UPLOAD_FILE_SUCCESS';
const UPLOAD_FILE_FAIL =
  'pages/eyewear/addoreditframe/components/eyeweareditor/components/fileupload/UPLOAD_FILE_FAIL';

const initialState = {
  uploaded: true,
};
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case UPLOAD_FILE:
      return {
        ...state,
        uploaded: false,
      };
    case UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        uploaded: true,
      };
    default:
      return {
        ...state,
      };
  }
}
export function fileUploadFormik(
  data,
  fileField,
  fileMeta = null,
  fileType = 'SignupImage',
  formatMessage,
  cb = () => {}
) {
  return dispatch => {
    let file = data[0];
    const fname = file.name;

    const fail = (failType, pos) => {
      uploadFail(failType, dispatch, formatMessage);
      // if (fileField)
      //   fileField.onChange(undefined);
      cb(null);
      return false;
    };

    const ext = fname.substr((~-fname.lastIndexOf('.') >>> 0) + 2);
    if (fileMeta) {
      if (fileMeta.ext) {
        if (ext.toUpperCase() !== fileMeta.ext.toUpperCase()) {
          return fail('format', 1);
        }
      }

      // file.size unit is bytes; fileMeta.size unit is KB
      if (file.size / 1024 > (fileMeta.size || Infinity)) {
        return fail('dimension', 2);
      }
    }

    const exts = ['PNG', 'JPG', 'JPEG', 'GIF', 'MP4', 'JSON', 'OTF'];
    if (_isEmpty(_intersection(exts, [ext.toUpperCase()]))) {
      return fail('format', 1);
    }

    if (fileType === 'Font') {
      if (ext === 'otf') {
        upload(data[0], fileType, dispatch).then(res =>
          cb({...res, filename: fname})
        );
        return;
      } else {
        return fail('fontformat');
      }
    }

    let xhr = new XMLHttpRequest();
    xhr.open('GET', file.preview, true);
    xhr.responseType = 'blob';
    xhr.onload = function(e) {
      if (this.status == 200) {
        const contentType = this.getResponseHeader('content-type');
        let blob = this.response;

        let fileReader = new FileReader();
        fileReader.readAsBinaryString(blob);
        fileReader.onload = function(e) {
          if (e.target.readyState == FileReader.DONE) {
            let imgblob = e.target.result;
            let sparkMD5 = new SparkMD5();
            sparkMD5.appendBinary(imgblob);
            let MD5 = sparkMD5.end();
            let img = new Image();
            img.src = file.preview;
            img.addEventListener('load', function() {
              file.width = img.naturalWidth;
              file.height = img.naturalHeight;
              if (fileMeta) {
                file.image_ref = fileMeta.image_ref;
              }
              file.md5 = MD5;

              upload(file, fileType, dispatch).then(function(result) {
                file.fileId = result;
                file.originalUrl = result;
                if (file.fileId) {
                  cb(file);
                } else {
                  cb(null);
                }
              });
            });
          }
        };
      }
    };
    xhr.send();
  };
}

function hasWrongAspectRatio(file, fileMeta) {
  if (fileMeta && fileMeta.ratioW && fileMeta.ratioH) {
    const idealHeight = (file.width / fileMeta.ratioW) * fileMeta.ratioH;
    return file.height > idealHeight + 1 || file.height < idealHeight - 1;
  }
  return false;
}

function hasWrongLiveLogoHeight(file, fileMeta) {
  if (fileMeta && fileMeta.height) {
    if (fileMeta.height2) {
      return file.height === fileMeta.height
        ? !(file.height === fileMeta.height)
        : !(file.height === fileMeta.height2);
    } else {
      return !(file.height === fileMeta.height);
    }
  }
  return false;
}

function upload(file, fileType, dispatch) {
  let data = new FormData();
  // data.append('fileType', fileType);
  // data.append('file_md5', file.md5);
  // data.append('file_width', file.width);
  // data.append('file_height', file.height);
  // data.append('file_ref', file.image_ref);
  file.ratio && data.append('ratio', file.ratio);
  file.optimize && data.append('optimize', file.optimize);

  data.append('file', file);
  data.append('pathType', 'GENERAL');
  dispatch({type: UPLOAD_FILE});
  return fetch('/smb-backend/sku/upload-image.action', {
    credentials: 'same-origin',
    method: 'POST',
    body: data,
  })
    .then(response => response.json())
    .then(function(json) {
      dispatch(uploadFileSuccess(json));
      return json;
    });
}

function uploadFail(type = 'dimension', dispatch, formatMessage) {
  // dispatch(
  //   notifActions.notifSend({
  //     message: (
  //       <Trans i18nKey="p.e.addoreditframe.fileupload.dimension">
  //         Please check image is correct dimension and size.
  //       </Trans>
  //     ),
  //     kind: 'error',
  //     dismissAfter: 3000,
  //   })
  // );
  dispatch({type: UPLOAD_FILE_FAIL});
}

function uploadFileSuccess(result) {
  return {
    type: UPLOAD_FILE_SUCCESS,
    result,
  };
}
